/**
 * Created by bas.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    Emitter        = require('cjs-emitter'),
    tools          = {
        ids: {
            base: 'network',
            test: 'speed-test'
        },
        /**
         * global flag to prevent ajax queries
         */
        ajaxStop: false,
        /**
         * Ajax request
         * @param {string} method "post", "get" or "head"
         * @param {string} url address
         * @param {function} callback on
         * @param {Object} [headers] list of optional headers like "charset", "Content-Type" and so on
         * @param {string} [type=text] data parsing mode: plain text (default), xml, json
         * @param {boolean} [async=true] send asynchronous request
         * @return {XMLHttpRequest} request object in case response headers are necessary
         * @example
         *   ajax('get', 'https://google.com/', function(data, status){console.info(data, status);}, {charset:'utf-8'})
         */
        ajax: function ( method, url, callback, headers, type, async ) {
            var jdata   = null,
                timeout = null,
                xhr     = new XMLHttpRequest(),
                hname, respText;

            async = async !== false;

            xhr.onreadystatechange = function () {
                if ( xhr.readyState === 4 ) {
                    clearTimeout(timeout);
                    if ( tools.ajaxStop ) {
                        //echo(xhr.status, 'AJAX ' + method.toUpperCase() + ' ' + url);
                        if ( typeof callback === 'function' ) { callback(null, null, null); }
                    } else {
                        //echo('status:' + xhr.status + ', length:' + xhr.responseText.length, title);
                        //echo(xhr.responseText, title);
                        if ( type === 'json' && xhr.status === 200 ) {
                            try {
                                jdata = JSON.parse(xhr.responseText);
                            } catch ( error ) {
                                //echo(error, 'AJAX JSON.parse');
                                jdata = null;
                            }
                        }
                        if ( typeof callback === 'function' ) {
                            if ( type === 'xml' ) {
                                respText = xhr.responseXML;
                            } else {
                                respText = (type === 'json' ? jdata : xhr.responseText);
                            }
                            callback(respText, xhr.status, xhr);
                        }
                    }
                }
            };
            xhr.open(method, url, async);
            // set headers if present
            if ( headers ) {
                for ( hname in headers ) {
                    if ( headers.hasOwnProperty(hname) ) {
                        xhr.setRequestHeader(hname, headers[hname]);
                    }
                }
            }
            xhr.send();
            //echo('sent', title);
            // abort after some time (60s)
            timeout = setTimeout(function () {
                xhr.abort();
                //echo('ABORT on timeout', title);
                if ( typeof callback === 'function' ) {
                    callback(null, 0);
                }
            }, 60000);

            return xhr;
        },
        getHumanReadableSpeed: function ( result ) {
            var speed = ((result.sizeDone * 1000) / result.timeWasted) * 8,
                postfix, divider;

            if ( speed >= 1048576 ) {
                postfix = 'Mbps';
                divider = 1048576;
            } else if ( speed >= 1024 ) {
                postfix = 'Kbps';
                divider = 1024;
            } else {
                postfix = 'bps';
                divider = 1;
            }

            return (speed / divider).toFixed(2) + ' ' + postfix;
        },
        /**
         * Get distance between two places.
         *
         * @param {number} latA location A latitude
         * @param {number} longA location A longitude
         * @param {number} latB  location B latitude
         * @param {number} longB  location B longitude
         *
         * @return {number} distance
         */
        calculateTheDistance: function ( latA, longA, latB, longB ) {
            var earthRadius = 6372795,

                lat1        = latA * Math.PI / 180,
                lat2        = latB * Math.PI / 180,
                long1       = longA * Math.PI / 180,
                long2       = longB * Math.PI / 180,

                cosLat1     = Math.cos(lat1),
                cosLat2     = Math.cos(lat2),
                sinLat1     = Math.sin(lat1),
                sinLat2     = Math.sin(lat2),

                delta       = long2 - long1,
                cosDelta    = Math.cos(delta),
                sinDelta    = Math.sin(delta),

                coordX      = (sinLat1 * sinLat2) + (cosLat1 * cosLat2 * cosDelta),
                coordY      = Math.sqrt(Math.pow(cosLat2 * sinDelta, 2) + Math.pow((cosLat1 * sinLat2) - (sinLat1 * cosLat2 * cosDelta), 2)),

                ad          = Math.atan2(coordY, coordX);

            return Math.ceil(ad * earthRadius);
        }
    },
    speedTest, gettext;


/**
 * Update manager. Listening daemon for records changes and emitting corresponding events to application.
 * Can emit events: progress, state, add, remove.
 *
 * @constructor
 * @extends Emitter
 */
function SpeedTest () {
    Emitter.call(this);
    // nearest server with test file
    this.server = '';
    /**
     * Stop this client and remove all it listeners. Use it for cleanup before application exit.
     */
    this.destroy = function () { this.events = {}; };
}

SpeedTest.prototype = Object.create(Emitter.prototype);
SpeedTest.prototype.constructor = SpeedTest;


/**
 * Find closest server for tests.
 *
 * @param {Object} config config
 * @param {Object} config.storage data storage
 */
SpeedTest.prototype.init = function ( config ) {
    var servers             = [
            {name: 'San Jose', lat: 37.3393900, long: -121.8949600, code: 'us'},
            {name: 'Washington D.C', lat: 38.8951100, long: -77.0363700, code: 'us'},
            {name: 'Amsterdam', lat: 52.3740300, long: 4.8896900, code: 'nl'},
            {name: 'Frankfurt', lat: 50.1166700, long: 8.6833300, code: 'de'}
        ],
        getMyLocationServer = 'http://weather.infomir.com.ua/getGeo.php',
        testBaseURL         = '.leaseweb.net/speedtest/10mb.bin',
        self                = this,
        user;

    // user old coordinates
    user = {
        lat: Number(config.storage.getItem('userLat')),
        lon: Number(config.storage.getItem('userLon'))
    };
    // get current coordinates
    tools.ajax('get', getMyLocationServer, function ( data ) {
        var ind;

        try {
            data = JSON.parse(data).data;
        } catch ( error ) {
            console.log(error, 'can\'t parse coordinates data from server');
            data = {lat: 0, lon: 0};
        }

        // if coordinates was changed update location data
        if ( (data.lat && data.lat !== user.lat) || (data.lon && data.lon !== user.lon) ) {
            config.storage.setItem('userLat', user.lat);
            config.storage.setItem('userLon', user.lon);
            user.lat = data.lat;
            user.lon = data.lon;
            // get closest to user server
            for ( ind = 0; ind < servers.length; ind++ ) {
                servers[ind].distance = tools.calculateTheDistance(user.lat, user.lon, servers[ind].lat, servers[ind].long);
            }
            servers.sort(function ( one, two ) {
                return one.distance - two.distance;
            });
            self.server = 'http://mirror.' + servers[0].code + testBaseURL;
            config.storage.setItem('server', self.server);
        } else {
            self.server = config.storage.getItem('server');
        }
    });
};

/**
 * Start test.
 *
 * @param {Object} config config
 * @param {Object} config.storage data storage
 */
SpeedTest.prototype.start = function ( config ) {
    var self = this,
        taskStates = {
            STOPPED: 0,
            WAITING: 1,
            RUNNING: 2,
            FINISHED: 3,
            TEMPORARY_ERROR: 4,
            PERMANENT_ERROR: 5
        },
        timerId, data;

    // start new test
    function startNewTest () {
        stbDownloadManager.AddMeasureJob(self.server || config.storage.getItem('server'));
        // watch for progress
        timerId = window.setInterval(function () {
            var info = JSON.parse(stbDownloadManager.GetMeasureInfo())[0],
                text;

            if ( info.state === taskStates.TEMPORARY_ERROR || info.state === taskStates.PERMANENT_ERROR ) {
                window.clearInterval(timerId);
                text = gettext('Error');
                stbDownloadManager.DeleteJob(info.id, false);
            } else if ( info.state === taskStates.WAITING || info.state === taskStates.RUNNING ) {
                text = gettext('Measure progress') + ' ' + Math.round(info.progressPct || 0) + '%';
            } else if ( info.state === taskStates.FINISHED ) {
                window.clearInterval(timerId);
                text = tools.getHumanReadableSpeed(info);
                stbDownloadManager.DeleteJob(info.id, false);
            }

            self.emit('progress', {code: info.state, text: text});
        }, 2000);
    }

    // find previous test data
    data = JSON.parse(stbDownloadManager.GetMeasureInfo());
    if ( data.length ) {
        data.forEach(function ( item ) {
            stbDownloadManager.DeleteJob(item.id, false);
        });
        // need some time to remove old data
        setTimeout(startNewTest, 100);
    } else {
        startNewTest();
    }
};


function buildSpeedTest ( config ) {
    return {
        id: 'networkSpeed',
        name: gettext('Network speed'),
        parent: tools.ids.base,
        type: 'option',
        description: gettext('Network speed'),
        icon: 'theme-icon-settings',
        title: gettext('Network speed'),
        config: {focusable: false},
        events: {
            click: function () {
                var self = this;

                speedTest.events['progress'] = undefined;
                speedTest.addListener('progress', function ( data ) {
                    self.setData({
                        data: [
                            {items: ['LAN: ' + (gSTB.GetLanLinkStatus() ? gettext('Available') : gettext('Not available'))]},
                            {items: ['WiFi: ' + (gSTB.GetWifiLinkStatus() ? gettext('Available') : gettext('Not available'))]},
                            {items: [gettext('Speed:') + ' ' + data.text]}
                        ]
                    });
                });
                speedTest.start(config);
            }
        },
        prepareForRender: function ( data, callback ) {
            callback([
                {items: ['LAN: ' + (gSTB.GetLanLinkStatus() ? gettext('Available') : gettext('Not available'))]},
                {items: ['WiFi: ' + (gSTB.GetWifiLinkStatus() ? gettext('Available') : gettext('Not available'))]},
                {items: [gettext('Speed:') + ' ' + gettext('Waiting')]}
            ]);
        },
        render: config.api.renders.popupLayoutList,
        data: {}
    };
}

speedTest = new SpeedTest();

module.exports = {
    onInit: function ( config, callback ) {
        gettextWrapper.load({
            name: window.core.environment.language,
            path: config.path + 'lang'
        }, function () {
            var coreDaemon = new (require('cjs-emitter'))();

            gettext = gettextWrapper.gettext;
            // wait until core.backend plugin will be ready for mode check
            coreDaemon.addListener('system:start', function () {
                if ( window.MODE_STALKER ) {
                    // stalker mode
                    window.core.backend.once('ready', function () {
                        speedTest.server = window.core.backend.settings.speedtest_url || '';
                        if ( config.storage.getItem('server') !== speedTest.server ) {
                            // test server url was changed so update it
                            config.storage.setItem('server', speedTest.server);
                        }
                    });
                } else {
                    // portal mode
                    speedTest.init(config);
                }
            });
            callback(null, coreDaemon);
        });
    },
    onAppInit: function ( config, callback ) {
        callback(null, {});
    },
    onSettingsInit: function ( config, callback ) {
        callback(null, {content: [buildSpeedTest(config)]});
    }
};
